import React from 'react';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import s from '../assets/styles/style.sass';
import SMSChangePhoneDialog from '../components/Dialog/smsChangePhoneDialog';
import SMSVerifyDialog from '../components/Dialog/smsVerifyDialog';
import SMSVerifyLoadingDialog from '../components/Dialog/smsVerifyLoadingDialog';
import SMSVerifySuccessDialog from '../components/Dialog/smsVerifySuccessDialog';
import { setIsSendingSMS } from '../actions/dialog';

const sendingTime = 60;
class smsCtrl extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    setIsSendingSMS: PropTypes.func.isRequired,
    isSendingSMS: PropTypes.bool.isRequired,
  };
  constructor(props) {
    super(props);
    let langType = props.currentLocale.split('-')[0]; // en-SG
    const lang = props.currentLocale.split('-')[1].toLowerCase();
    if (lang === 'hk') {
      langType = `${langType}-${lang}`;
    } else if (['sg', 'in'].includes(lang)) {
      langType = 'en';
    } else {
      langType = lang;
    }
    this.state = {
      isChangeable: true,
      isMobilePhone: true,
      second: sendingTime,
      modelDataText: require(`../assets/src/scripts/gogovan/sms/${lang}/${langType}.json`),
    };
    this.timeChange = this.timeChange.bind(this);
    this.onSetIsMobilePhone = this.onSetIsMobilePhone.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isSendingSMS) {
      this.timeChange();
    }
  }

  onClickIsChangeable() {
    this.setState({ isChangeable: !this.state.isChangeable });
  }

  onSetIsMobilePhone(bool) {
    this.setState({ isMobilePhone: bool }, () => {
      this.forceUpdate();
    });
  }

  timeChange() {
    const countdown = setInterval(() => {
      this.setState({ second: (this.state.second -= 1) });
      if (this.state.second === 0) {
        clearInterval(countdown);
        this.props.setIsSendingSMS(false);
        this.setState({ second: sendingTime });
      }
    }, 1000);
  }

  render() {
    return (
      <div>
        <div id="step-one">
          <SMSChangePhoneDialog
            second={this.state.second}
            onSetIsMobilePhone={this.onSetIsMobilePhone}
            modelDataText={this.state.modelDataText}
          />
        </div>

        <div id="step-two">
          <SMSVerifyDialog
            second={this.state.second}
            isMobilePhone={this.state.isMobilePhone}
            onSetIsMobilePhone={this.onSetIsMobilePhone}
            modelDataText={this.state.modelDataText}
          />
        </div>

        <div id="sms-verifiying">
          <SMSVerifyLoadingDialog modelDataText={this.state.modelDataText} />
        </div>

        <div id="sms-verified">
          <SMSVerifySuccessDialog modelDataText={this.state.modelDataText} />
        </div>
      </div>
    );
  }
}

const mapState = state => ({
  currentLocale: state.intl.locale,
  isSendingSMS: state.dialog.isSendingSMS,
});
const mapDispatch = {
  setIsSendingSMS,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s)(smsCtrl),
);



// WEBPACK FOOTER //
// ./src/ctrl/smsCtrl.js